import {
    ClickMix,
    Cobranca,
    Comandas,
    Fidelidade,
    Ifood,
    Inventario,
    LojaIntegrada,
    Mobile,
    NuvemShop,
    OSuper,
    Pedidos,
    PidoMe,
    Revisao,
    Setores,
    SiteMercado,
    SupermercadosNow,
    TerminalProducao,
    V4,
    V4Tarefas
} from '../../components/sistemas-integracao/sistemas-integracao'
import Ellipse1 from '../../components/public/v4/ellipse1169101-i8gk.svg'
import Ellipse2 from '../../components/public/v4/ellipse1169102-b18m.svg'
import Back1 from '../../components/public/background/Background V4/1.png'
import Back2 from '../../components/public/background/Background V4/2.png'
import Back3 from '../../components/public/background/Background V4/3.png'
import Back4 from '../../components/public/background/Background V4/4 .png'
import BackFiguras1 from '../../components/public/background/Background V4/Figuras/1.png'
import BackFiguras2 from '../../components/public/background/Background V4/Figuras/2.png'
import BackFiguras3 from '../../components/public/background/Background V4/Figuras/3.png'
import BackFiguras4 from '../../components/public/background/Background V4/Figuras/4.png'
import BackFiguras5 from '../../components/public/background/Background V4/Figuras/5.png'
import BackFiguras6 from '../../components/public/background/Background V4/Figuras/6.png'
import BackDesktop1 from '../../components/public/background/Background V4/Desktop/back1.png'
import BackDesktop2 from '../../components/public/background/Background V4/Desktop/back2.png'
import BackDesktop3 from '../../components/public/background/Background V4/Desktop/back3.png'
import BackDesktop4 from '../../components/public/background/Background V4/Desktop/back4.png'
import BackFigurasDesktop1 from '../../components/public/background/Background V4/Desktop/Figuras/backFigu1.png'
import BackFigurasDesktop2 from '../../components/public/background/Background V4/Desktop/Figuras/backFigu2.png'
import BackFigurasDesktop3 from '../../components/public/background/Background V4/Desktop/Figuras/backFigu3.png'
import BackFigurasDesktop4 from '../../components/public/background/Background V4/Desktop/Figuras/backFigu4.png'
import BackFigurasDesktop5 from '../../components/public/background/Background V4/Desktop/Figuras/backFigu5.png'
import BackFigurasDesktop6 from '../../components/public/background/Background V4/Desktop/Figuras/backFigu6.png'
import BackFigurasDesktop7 from '../../components/public/background/Background V4/Desktop/Figuras/backFigu7.png'
import BackFigurasDesktop8 from '../../components/public/background/Background V4/Desktop/Figuras/backFigu8.png'
import image1414536 from '../../components/public/v4/image1414536-q97-200w.png'
import PcCortado from '../../components/public/v4/Group 1215.png'
import Image1 from '../../components/public/imagens sistema/V4/Image1.png'
import Image2 from '../../components/public/imagens sistema/V4/Image2.png'
import Image3 from '../../components/public/imagens sistema/V4/Image3.png'
import Image4 from '../../components/public/imagens sistema/V4/Image4.png'
import Image5 from '../../components/public/imagens sistema/V4/Image5.png'
import './autoComV4.css'
import './background.css'
import { IconsGrande, IconsPequeno } from '../../components/icons-sistema/icons-sistema'
import { useKeenSlider } from 'keen-slider/react'
import SqlServer from '../../components/public/icons/Restantes/SqlServer.svg'
import WebSite from '../../components/public/icons/Restantes/WebSite.svg'
import Multiloja from '../../components/public/icons/Restantes/MultiLoja.svg'
import MaximaSeguranca from '../../components/public/icons/Restantes/MaximaSeguranca.svg'
import Computadorv4 from '../../components/public/v4/Computador v4.png'
import ComputadorV4Abaixo from '../../components/public/v4/Computador v4 abaixo.png'
import WhiteLabel from '../../components/public/pdv/white-label.png'
import SuporteTecnico from '../../components/public/pdv/suporte-tecnico.png'
import { Link } from 'react-router-dom'
import { QrCode } from '../../components/qrcode/qrcode'
import { useSessaoAtual } from '../../../services/providers/sessao-atual-provider/sessao-atual-provider'
import { useHistory } from 'react-router'
import { useEffect } from 'react'
import { Footer } from '../../components/footer/footer'
import { Helmet } from 'react-helmet'
import { Box, Button, Divider, IconButton, List, ListItemIcon, SwipeableDrawer, Toolbar, Typography, useTheme } from '@material-ui/core'
import { useState } from 'react'
import clsx from 'clsx';
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import MenuIcon from '@material-ui/icons/Menu';
import { useStyles } from './v4-style'
import { BaixasStorageKeys, useBaixasStorage } from '../../../services/use-cases/baixas-storage'

export const SaurusV4 = () => {
    const { DefinirRota, IsValidSession } = useSessaoAtual()
    const classes = useStyles()
    const theme = useTheme();
    const history = useHistory()
    const [open, setOpen] = useState(false);
    const { getRegister } = useBaixasStorage();
    const user = getRegister(BaixasStorageKeys.data)

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const toggleDrawer = (open: boolean) => (
        event: React.KeyboardEvent | React.MouseEvent,
    ) => {
        if (
            event &&
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
                (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }

        setOpen(false);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    DefinirRota('/saurus-v4')
    useEffect(() => {
        if (!IsValidSession) history.push('/')
    })

    const [refCallback] = useKeenSlider(
        {
            slides: { perView: 'auto', spacing: 10 },
        },
        [
            // add plugins here
        ]
    )

    return (

        <>
            {user.id ?
                <>
                    <Toolbar className={classes.appBar}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            className={clsx(classes.menuButton, open && classes.hide)}
                        >
                            <MenuIcon className={classes.menuButton} />
                            <Typography style={{ fontSize: '17px', padding: '0 15px' }} variant="h4">
                                Saurus V4
                            </Typography>
                        </IconButton>
                        {/* <QrCode backColor="#386D9F" /> */}
                    </Toolbar>
                    <SwipeableDrawer
                        className={classes.drawer}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        open={open}
                        anchor={'left'}
                        onClose={toggleDrawer(false)}
                        onOpen={toggleDrawer(true)}
                    >

                        <div className={classes.drawerHeader}>
                            <Typography style={{ fontSize: '17px', padding: '0px 85px 0 0' }} variant="h4">
                                Saurus V4
                            </Typography>
                            <IconButton onClick={handleDrawerClose}>
                                {theme.direction === "ltr" ? (
                                    <ChevronLeftIcon />
                                ) : (
                                    <ChevronRightIcon />
                                )}
                            </IconButton>

                        </div>
                        <Divider />
                        <div style={{ backgroundColor: '#fafafa' }}>
                            <List >
                                <ListItem button className={classes.listFilho}>
                                    <ListItemIcon onClick={() => history.push('/cadastrar')}>
                                        Cadastrar-se
                                    </ListItemIcon>
                                </ListItem>
                            </List>
                            <Divider />
                            <ListItem button className={classes.list} >
                                <ListItemIcon onClick={() => history.push('/representante')}>
                                    Representante
                                </ListItemIcon>
                            </ListItem>
                        </div>
                        <Box flexGrow={1} bgcolor='#fafafa' />  {/* jogou o sair para baixo */}
                        <Divider classes={{ root: classes.divider }} />
                        <ListItem button className={classes.list} >
                            <ListItemIcon onClick={() => history.push('/login')}>
                                Sair
                            </ListItemIcon>
                        </ListItem>
                    </SwipeableDrawer>
                </>

                :
                <>
                    <div style={{ padding: '8px 8px', display: 'flex', justifyContent: 'space-between' }}>
                        <Button variant='outlined' style={{ backgroundColor: '#E77525', zIndex: 1, color: '#fff' }} onClick={() => history.push('/login')}>Logar</Button>
                        <Button variant='outlined' style={{ backgroundColor: '#E77525', zIndex: 1, color: '#fff' }} onClick={() => history.push('/representante')}>Representante</Button>
                    </div>
                </>
            }

            <div className="saurusV4Page">
                <Helmet>
                    <title>Saurus V4 - Saurus AutoCom</title>
                    <meta content="#E77525" name="theme-color" />
                </Helmet>
                <div className="d-none-pc">
                    <img src={Back1} alt="" className="background1" />
                    <img src={Back2} alt="" className="background2" />
                    <img src={Back3} alt="" className="background3" />
                    <img src={Back4} alt="" className="background4" />
                    <img src={BackFiguras1} alt="" className="background-figuras1" />
                    <img src={BackFiguras2} alt="" className="background-figuras2" />
                    <img src={BackFiguras3} alt="" className="background-figuras3" />
                    <img src={BackFiguras3} alt="" className="background-figuras4" />
                    <img src={BackFiguras4} alt="" className="background-figuras5" />
                    <img src={BackFiguras5} alt="" className="background-figuras6" />
                    <img src={BackFiguras4} alt="" className="background-figuras7" />
                    <img src={BackFiguras6} alt="" className="background-figuras8" />
                    <img src={BackFiguras5} alt="" className="background-figuras9" />
                    <img src={BackFiguras6} alt="" className="background-figuras10" />
                    <img src={BackFiguras4} alt="" className="background-figuras11" />
                </div>
                <div className="d-none-celular">
                    <img src={BackDesktop1} alt="" className="background-desk1" />
                    <img src={BackDesktop2} alt="" className="background-desk2" />
                    <img src={BackDesktop3} alt="" className="background-desk3" />
                    <img src={BackDesktop4} alt="" className="background-desk4" />
                    <img src={BackFigurasDesktop1} alt="" className="background-figuras-desk1" />
                    <img src={BackFigurasDesktop2} alt="" className="background-figuras-desk2" />
                    <img src={BackFigurasDesktop2} alt="" className="background-figuras-desk2-1" />
                    <img src={BackFigurasDesktop2} alt="" className="background-figuras-desk2-2" />
                    <img src={BackFigurasDesktop3} alt="" className="background-figuras-desk3" />
                    <img src={BackFigurasDesktop4} alt="" className="background-figuras-desk4" />
                    <img src={BackFigurasDesktop5} alt="" className="background-figuras-desk5" />
                    <img src={BackFigurasDesktop6} alt="" className="background-figuras-desk6" />
                    <img src={BackFigurasDesktop7} alt="" className="background-figuras-desk7" />
                    <img src={BackFigurasDesktop7} alt="" className="background-figuras-desk7-1" />
                    <img src={BackFigurasDesktop8} alt="" className="background-figuras-desk8" />
                    <img src={BackFigurasDesktop8} alt="" className="background-figuras-desk8-1" />
                </div>
                <div className="p-d-v1430-container">
                    <div className="p-d-v1430-p-d-v1430">
                        {user.id ?
                            <div className="p-d-v1430-group11911453" >
                            </div>
                            :
                            <div className="saurusV4Page .p-d-v1430-group45218" >
                            </div>
                        }
                        <div className="sliders">
                            <div id="my-keen-slider" ref={refCallback} className="keen-slider container">
                                <div className="keen-slider__slide slide-servicos-grande">
                                    <img src={IconsGrande().V4Grande} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/saurus-mobile">
                                        <img src={IconsPequeno().MobilePequeno} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/touchone">
                                        <img src={IconsPequeno().TouchOnePequeno} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/saurus-pdv">
                                        <img src={IconsPequeno().PDVPequeno} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <hr className="hr-cinza" />
                        </div>
                        <div className="container">
                            <div className="row mb-4">
                                <div className="col-lg-6 col-12">
                                    <div className="p-d-v1430-conheao-saurus-p-d-v15174">
                                        <span className="p-d-v1430-text02">
                                            <span className="p-d-v1430-text03">Conheça o</span>
                                            <div className="text-saurus-pdv">
                                                <span className="p-d-v1430-text04">
                                                    <span>SAURUS</span>
                                                </span>
                                                <span className="p-d-v1430-text08">V4</span>
                                            </div>
                                        </span>
                                    </div>
                                    <div className="content-sistema-versatil">
                                        <span className="p-d-v1430-text38">
                                            <span className="p-d-v1430-text39">O sistema de gestão web que é o </span>
                                            <span className="p-d-v1430-text40">ERP do empresário </span>
                                            <span className="p-d-v1430-text39">e a retaguarda </span>
                                            <span className="p-d-v1430-text40">administrativa </span>
                                            <span className="p-d-v1430-text39">do </span>
                                            <span className="p-d-v1430-text40">lojista.</span>
                                            <span className="p-d-v1430-text41">
                                                <br />
                                                <span>Com diversos apps para </span>
                                            </span>
                                            <span className="p-d-v1430-text40">Android </span>
                                            <span className="p-d-v1430-text46">que complementam a solução.</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 d-none-celular">
                                    <img src={Computadorv4} style={{ maxWidth: "100%", marginTop: "50px" }} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="container icons-container">
                            <div className="row">
                                <div className="col-6 col-md-3">
                                    <div className="p-d-v1430-frentedecaixa11839">
                                        <img src={SqlServer} alt="Group480879" className="p-d-v1430-image07" />
                                        <span className="p-d-v1430-text09">
                                            <span className="p-d-v1430-text10">SQL SERVER</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-md-3">
                                    <div className="p-d-v1430-retaguardalocal11847">
                                        <img src={WebSite} alt="Group4721050" className="p-d-v1430-image21" />
                                        <span className="p-d-v1430-text31">
                                            <span className="p-d-v1430-text32">100% ONLINE</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-md-3">
                                    <div className="p-d-v1430-cupom-s-a-t-n-f-ce11850">
                                        <img src={Multiloja} alt="Group4721012" className="p-d-v1430-image22" />
                                        <span className="p-d-v1430-text33">
                                            <span className="p-d-v1430-text34">
                                                <span>MULTILOJA</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-md-3">
                                    <div className="p-d-v1430-retaguardalocal11847">
                                        <img src={MaximaSeguranca} alt="Group4721050" className="p-d-v1430-image21" />
                                        <span className="p-d-v1430-text31">
                                            <span className="p-d-v1430-text32">MÁXIMA SEGURANÇA</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="my-keen-sliderr" ref={refCallback} className="keen-slider container">
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image1} rel="noreferrer" target="_blank">
                                    <img src={Image1} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image2} rel="noreferrer" target="_blank">
                                    <img src={Image2} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image3} rel="noreferrer" target="_blank">
                                    <img src={Image3} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image4} rel="noreferrer" target="_blank">
                                    <img src={Image4} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image5} rel="noreferrer" target="_blank">
                                    <img src={Image5} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                        </div>
                        <div className="container">
                            <hr className="hr-cinza" />
                        </div>
                        <div className="container d-none-pc">
                            <div className="p-d-v1430-text48">
                                <span>
                                    <span className="p-d-v1430-text54">A GESTÃO DA <br /><span>EMPRESA</span> A UM <br /><span>CLIQUE DE
                                        DISTÂNCIA</span></span>
                                </span>
                            </div>
                            <span className="p-d-v1430-text87">
                                <span className="p-d-v1430-text88">Reúne </span>
                                <span className="p-d-v1430-text89">simplicidade de operação </span>
                                <span className="p-d-v1430-text90">e conceitos de gestão avançados, com </span>
                                <span className="p-d-v1430-text89">sofisticados recursos </span>
                                <span className="p-d-v1430-text92">de análise de resultados.</span>
                            </span>
                        </div>
                        <div className="pdv-maquininha d-none-pc">
                            <img src={PcCortado} alt="Group4721050" className="p-d-v1430-image21" />
                        </div>
                        <div className="container container-apps-integracoes">
                            <div className="row">
                                <div className="col-lg-5 col-12 apps-integracoes">
                                    <div className="margin-bottom-1rem">
                                        <span className="p-d-v1430-text55">
                                            <span className="p-d-v1430-text56">Apps e Integrações</span>
                                        </span>
                                        <hr className="hr-colorido" />
                                    </div>
                                    <div className="images-app-integracoes">
                                        <div className="row">
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Mobile()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Comandas()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={V4()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Revisao()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={TerminalProducao()} alt="Rectangle8658211807"
                                                    className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Pedidos()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Cobranca()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Setores()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Inventario()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={V4Tarefas()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Fidelidade()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="margin-bottom-1rem">
                                        <span className="p-d-v1430-text55">
                                            <span className="p-d-v1430-text58">Integrações</span>
                                        </span>
                                        <hr className="hr-colorido" />
                                    </div>
                                    <div className="images-app-integracoes">
                                        <div className="row">
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={LojaIntegrada()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Ifood()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={NuvemShop()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={SiteMercado()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={ClickMix()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={SupermercadosNow()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={OSuper()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={PidoMe()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 d-none-celular">
                                    <div className='ms-4'>
                                        <div className="p-d-v1430-text48">
                                            <span>
                                                <span className="p-d-v1430-text54">A GESTÃO DA <br /><span>EMPRESA</span> A UM <br /><span>CLIQUE DE
                                                    DISTÂNCIA</span></span>
                                            </span>
                                        </div>
                                        <div className="mb-5">
                                            <span className="p-d-v1430-text87">
                                                <span className="p-d-v1430-text88">Reúne </span>
                                                <span className="p-d-v1430-text89">simplicidade de operação </span>
                                                <span className="p-d-v1430-text90">e conceitos de gestão avançados, com </span>
                                                <span className="p-d-v1430-text89">sofisticados recursos </span>
                                                <span className="p-d-v1430-text92">de análise de resultados.</span>
                                            </span>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <img src={ComputadorV4Abaixo} style={{ maxWidth: "100%" }} alt="" />
                                            </div>
                                            <div className="col-6 mb-5">
                                                <div className="d-flex mb-5">
                                                    <img src={WhiteLabel} alt="" />
                                                    <div>
                                                        <span className="white-suporte">WHITE LABEL</span>
                                                        <br />
                                                        <span className="white-suporte-texto">
                                                            O <span>SAURUS PDV</span> também
                                                            permite customização para
                                                            que o sistema tenha a
                                                            identidade da sua marca!
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="d-flex">
                                                    <img src={SuporteTecnico} alt="" />
                                                    <div className="ms-3">
                                                        <span className="white-suporte">SUPORTE TÉCNICO</span>
                                                        <br />
                                                        <span className="white-suporte-texto">
                                                            Equipe <span>especializada </span>
                                                            no atendimento à
                                                            revendedores.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 mt-5 pb-3">
                                                <a className="p-d-v1430-acessarpelogoogle11163" rel="noreferrer noopener" href='https://saurus.blob.core.windows.net/autocom/V4.pdf' target="_blank">
                                                    <img src={image1414536} alt="image1414536" className="p-d-v1430-image36" />
                                                    <span className="p-d-v1430-text60">PDF</span>
                                                </a>
                                                <a className="p-d-v1430-adicionar406885" target="_blank" href="https://saurus.com.br/saurus-v4/" rel="noreferrer noopener">
                                                    <span className="p-d-v1430-text62">Mais informações</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container d-none-pc pb-3">
                            <a className="p-d-v1430-acessarpelogoogle11163" rel="noreferrer noopener" href='https://saurus.blob.core.windows.net/autocom/V4.pdf' target="_blank">
                                <img src={image1414536} alt="image1414536" className="p-d-v1430-image36" />
                                <span className="p-d-v1430-text60">PDF</span>
                            </a>
                            <a className="p-d-v1430-adicionar406885" href="https://saurus.com.br/saurus-v4/" target="_blank" rel="noreferrer">
                                <span className="p-d-v1430-text62">Mais informações</span>
                            </a>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>

    )
}